import { PropertyDetails, UploadedDocument } from '@urbanx/agx-ui-components';

export interface Comparatives {
  comparativeType: ComparativeType;
  searchAddresses?: ComparativeAddress[];
  manualAddresses?: ComparativeAddress[];
  attachedFileInfo?: UploadedDocument;
}

export enum ComparativeType {
  Search = 'Search',
  Manual = 'Manual',
  AttachAsFile = 'AttachAsFile',
  NotAvailable = 'NotAvailable',
}

export interface ComparativeAddress {
  propertyAddress: string;
  soldPrice?: number;
  distanceInKilometers?: number;
  propertyDetails?: PropertyDetails;
  settlementDate?: string;
}
